// Source: https://community.shopify.com/c/Technical-Q-A/proper-way-to-run-jquery-based-script-on-page-load/td-p/514411
// Demo: http://jsfiddle.net/h89vz3k2/3/





// TODO: Check out this for adding custom donation amount:
// https://community.shopify.com/c/Shopify-Design/Adding-Gratuity-Tips/td-p/283177

// Also this for money input box:
// https://plentz.github.io/jquery-maskmoney/





$(window).on('load', function() {
  $('#organization-selector').change(function () {
    console.log('Test!');
    var selected = $('#organization-selector option:selected').val();

    // Update charity in text above listbox
    if (selected == 'none'){
      $('#organization-span').attr('style', '');
      $('#organization-span').text('a charity or nonprofit that POTUS hates. Choose one below');    
    } else {
      $('#organization-span').attr('style', 'color: #090c9b; font-weight: bold');
      $('#organization-span').text($('#organization-selector option:selected').val());
    }

    // Update charity description
    switch (selected){
      case 'UNICEF USA':
        $('#organization-description').html('UNICEF USA is a United Nations special program that has '
            + 'become one of the world\'s most prominent providers of vaccines. Since the onset of the '
            + 'Coronavirus pandemic, they have provided 7.6M N95 masks and 1.7M COVID-19 tests to those '
            + 'in need. UNICEF not only trains health care workers on infection prevention, but also '
            + 'focuses on improving lives of the world\'s children by providing holistic mental-health '
            + 'and psychological support that is so critical to hundreds of millions of families '
            + '(<a href="https://www.unicefusa.org/mission/covid-19">source</a>). Donate to UNICEF USA so '
            + 'we can get through this pandemic together. Learn more at <a href="https://www.unicefusa.org/">unicefusa.org</a>.');
        console.log('Test! (UNICEF USA)');
        break;
      case '350':
        $('#organization-description').html('350 is an organization fighting to stop the use of fossil fuels, transition to 100% renewable energy, and build a '
            + 'nationwide movement of activists working to create a livable future for all. Donate to 350 to remove the influence '
            + 'of the fossil fuel industry on our government and reverse the actions Trump has taken to degrade the Earth, '
            + 'including putting thousands of plastic straws into our oceans. Learn more at <a href="https://350.org/" target="_blank">350.org</a>.');
        break;
      case 'Planned Parenthood Federation of America':
        $('#organization-description').html('The Planned Parenthood Federation of America fights for the critical reproductive rights that the Trump administration are '
            + 'slowly eroding through limiting access to abortions and affordable birth control. Donate to Planned Parenthood '
            + 'to protect the legal equality of women in the United States against the administration’s efforts to eliminate '
            + 'their bodily autonomy and freedom. Learn more at <a href="https://www.plannedparenthood.org/" target="_blank">plannedparenthood.com</a>.');
        break;
      case 'RAICES':
        $('#organization-description').html('The Refugee and Immigrant Center for Education and Legal Services (RAICES) actively combats the destructive '
            + 'immigration policies of the Trump administration by providing free and low-cost legal services to immigrant '
            + 'children, families, and refugees. Donate to RAICES to reverse Trump’s border catastrophe and support their family '
            + 'reunification project that brings migrant families back together. Learn more at <a href="https://www.raicestexas.org/" target="_blank">raicestexas.org</a>.')
        break;
      case 'American Civil Liberties Union':
        $('#organization-description').html('The mission of the American Civil Liberties Union (ACLU) is to protect the individual rights and liberties of the '
            + 'American people across a variety of issues from harmful government actions. Donate to the ACLU to protect every '
            + 'individual on American soil from Trump’s hostile conduct against the Constitution, whether your keystone issue is '
            + 'immigration rights, LGBT rights, free speech, religious freedom, or more. Learn more at <a href="https://www.aclu.org/" target="_blank">aclu.org</a>.');
        break;
      case 'Everytown for Gun Safety':
        $('#organization-description').html('Everytown for Gun Safety is a coalition of parents, teachers, survivors, students, gun owners, and others working '
            + 'to end the epidemic of gun violence in America through education, advocacy, and challenging the gun lobby and the '
            + 'NRA. Donate to Everytown for Gun Safety to stop the influence of the NRA from Trump down to our state legislators '
            + 'and save up to 400,00 lives every year by building safer communities using stronger legislation. Learn more at '
            + '<a href="https://everytown.org/who-we-are/" target="_blank">everytown.org</a>.');
        break;
      case 'Southern Poverty Law Center':
        $('#organization-description').html('The Southern Poverty Law Center takes direct action against hate and fascism and seeks justice through litigation, '
            + 'education, monitoring, of hate crimes in the United States. Donate to the Southern Poverty Law Center to fight '
            + 'against the Trump Administration’s dictator-like regime and end the destructive forces of hate in this country. '
            + 'Learn more at <a href="https://www.splcenter.org/" target="_blank">splcenter.org</a>.');
        break;
      case 'none':
        $('#organization-description').html('Select a charity to learn more about it here, or visit our '
            + '<a href="https://www.trumpsuks.com/pages/charities-trumpsuks-supports" target="_blank">Charities We Support</a> page.');  
    }

    // Put a "the" before charity if appropriate
    if (selected == 'Australian Red Cross'
      || selected == 'Planned Parenthood Federation of America' 
      || selected == 'American Civil Liberties Union'
      || selected == 'Southern Poverty Law Center'){
      $('#the-span').text('the ');
    } else {
      $('#the-span').text('');
    }

    // Disable buy button if no organization is selected
    if (selected == 'none'){
      $('#hide-if-no-organization').find('button').attr('disabled', true);
    } else {
      $('#hide-if-no-organization').find('button').attr('disabled', false);
    }
  });
});

// // Set CSS for HulkApps options area
// $(window).on('ready', function() {
//   $('.hulkapps_option_set').parent().parent().css('background-color: red;');
// });